import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Button, Typography } from '@mui/material';
// components
import { getRoleName } from '../auth/utils';
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { ForbiddenIllustration } from '../assets/illustrations';
import { ROLES } from '../utils/constant';
import { PATH_NAVIGATE_FOR_EMPLOYEE, PATH_NAVIGATE_NOT_FOR_EMPLOYEE } from '../config-global';

// ----------------------------------------------------------------------

export default function Page403() {
  return (
    <>
      <Helmet>
        <title> {` 403 Forbidden | ${process.env.REACT_APP_NAME} `}</title>
      </Helmet>

      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            No permission
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            The page you&apos;re trying access has restricted access.
            <br />
            Please refer to your system administrator
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: 5 }} />
        </m.div>

        <Button
          component={RouterLink}
          to={
            getRoleName() === ROLES.EMPLOYEE
              ? PATH_NAVIGATE_FOR_EMPLOYEE
              : PATH_NAVIGATE_NOT_FOR_EMPLOYEE
          }
          size="large"
          variant="contained"
        >
          Go to Home
        </Button>
      </MotionContainer>
    </>
  );
}
